import React, {useState, useEffect } from "react";

const gallery = [
  {
    src: "/img/photo1.jpg",
    alt: "Doctora-paciente"
  },
  {
    src: "/img/photo2.jpeg",
    alt: "Aislado Absoluto"
  },
  {
    src: "/img/photo3.jpeg",
    alt: "Zoom"
  },
  {
    src: "/img/photo4.jpeg",
    alt: "Dientes"
  },
  {
    src: "/img/DSDCard.jpg",
    alt: "DSD"
  },
  {
    src: "/img/invisalignCard.jpg",
    alt: "Zoom"
  },
  {
    src: "/img/CarillasCard.jpg",
    alt: "Zoom"
  }
];

export default function Gallery() {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % gallery.length);
    }, 2000); // los segundos

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="gallery" id="galeria">
      <h2>Galería</h2>
      <div className="gallery-container">
        <div className="gallery-main">
          <img
            src={gallery[currentImage].src}
            alt={gallery[currentImage].alt}
            className="gallery-image"
          />

          {/* Indicadores de puntos */}
          <div className="gallery-indicators">
            {gallery.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentImage ? 'active' : ''}`}
                onClick={() => setCurrentImage(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
